import CryptoJS from 'crypto-js'
import {request} from "@/manager/net_manager";
import {computed} from "vue";
import store from "@/store";

export const mapSpriteResources = require('@/assets/sprite/map-sprite-manifest.json')
export const mapPieceResources = require('@/assets/sprite/map-piece-manifest.json')

export const placeholderImage = require('../assets/image/placeholder.png')
export const propsDefaultImage = require('../assets/image/props_back_default.png')

export const featOptions = ['G', 'F', 'E', 'D', 'C', 'B', 'A', 'S', 'U']

export const stageMapTypes = [
    {
        id: 0,
        name: '场景地图',
        desc: '仅链接者可以变更场景内容、角色位置'
    }, {
        id: 1,
        name: '战斗地图',
        desc: '链接者可以变更场景内容、角色位置，选中者出演角色可以在行动回合改变自身角色位置'
    },
]

const descriptiveDict = {
    'max_hp': 'HP上限的',
    'max_mp': 'MP上限的',
    'max_san': 'SAN上限的',
    'max_qi': '剑气数上限的',
    'max_str': '力量上限的',
    'max_dex': '敏捷上限的',
    'max_con': '体质上限的',
    'max_siz': '体型上限的',
    'max_app': '容貌上限的',
    'max_edu': '教育上限的',
    'max_int': '智力上限的',
    'max_pow': '意志上限的',
    'max_luck': '幸运上限的',
    'cur_hp': '当前HP的',
    'cur_mp': '当前MP的',
    'cur_san': '当前SAN的',
    'cur_qi': '当前剑气数的',
    'per_turn': '每回合',
    'least': '至少',
}

const resourceDict = {
    'hp': 'HP',
    'mp': 'MP',
    'san': 'SAN',
    'spell': '符咒',
    'qi': '剑气',
    'str': '力量',
    'dex': '敏捷',
    'con': '体质',
    'siz': '体型',
    'app': '容貌',
    'edu': '教育',
    'int': '智力',
    'pow': '意志',
    'luck': '幸运',
    'root_hp': 'HP上限',
    'root_mp': 'MP上限',
    'root_san': 'SAN上限',
    'assets': '资产点数',
}

export const gradientPercentageColors = [
    {color: '#8F9AA3', percentage: 20},
    {color: '#6CB88A', percentage: 40},
    {color: '#6CA8DA', percentage: 60},
    {color: '#F6D27C', percentage: 80},
    {color: '#D66C6C', percentage: 100},
]

export const getPosition = function (userType) {
    userType = userType.toString()
    switch (userType) {
        case '0':
            return '蜃'
        case '1':
            return '结社'
        case '2':
            return '链接者'
        case '3':
            return '选中者'
        default:
            return '偷渡者'
    }
}

export const getGender = function (userType) {
    switch (userType.toString()) {
        case '0':
            return '未设定'
        case '1':
            return '男性'
        case '2':
            return '女性'
        default:
            return '未设定'
    }
}

export const getRace = function (userType) {
    switch (userType) {
        case 1:
            return '白种人类'
        case 2:
            return '黄种人类'
        case 3:
            return '棕种人类'
        case 4:
            return '黑种人类'
        default:
            return '未设定'
    }
}

export const getProperty = function (key) {
    switch (key) {
        case 'str':
            return '力量'
        case 'con':
            return '体质'
        case 'siz':
            return '体型'
        case 'dex':
            return '敏捷'
        case 'app':
            return '容貌'
        case 'int':
            return '智力'
        case 'edu':
            return '教育'
        case 'pow':
            return '意志'
        case 'luck':
            return '幸运'
        default:
            return '未定义属性'
    }
}

export const getDamageAndBuild = function (role, isMental = false) {
    let value = parseInt(role['properties']['str']) + parseInt(role['properties']['siz'])
    if (isMental) {
        value = parseInt(role['properties']['pow']) + parseInt(role['properties']['con'])
    }

    if (value >= 285) {
        return ['3d6', 4]
    } else if (value >= 205) {
        return ['2d6', 3]
    } else if (value >= 165) {
        return ['1d6', 2]
    } else if (value >= 125) {
        return ['1d4', 1]
    } else if (value >= 85) {
        return ['0', 0]
    } else if (value >= 65) {
        return ['-1', -1]
    } else {
        return ['-2', -2]
    }
}

export const getMovement = function (role) {
    const age = role['age'] ?? 20
    let adjust_age = age > 49 ? -2 : age > 39 ? -1 : 0

    let adjust_property = 0
    if (role['properties']['str'] > role['properties']['siz']) {
        adjust_property++
    }
    if (role['properties']['dex'] > role['properties']['siz']) {
        adjust_property++
    }

    return 5 + adjust_property + adjust_age
}

export const getHealthPoint = function (role) {
    return Math.floor((role['properties']['con'] + role['properties']['siz']) * 0.15)
}

export const getMagicPoint = function (role) {
    return Math.floor(role['properties']['pow'] * 0.2 + role['properties']['con'] * 0.1)
}

export const getCapabilityBaseValue = function (value, properties = null) {
    // console.log(JSON.stringify(value) )
    if (typeof value === 'number' || !value.includes(',')) {
        return [value, value]
    }

    const parts = value.split(',').map(part => part.trim())

    if (parts.length === 2 && !isNaN(parts[0])) {
        let numericPart = parseFloat(parts[0])
        let variablePart = getProperty(parts[1])
        let rolePropertyValue = properties ? parseInt(properties[parts[1]]) : 0

        return [Math.floor(rolePropertyValue * numericPart), `${variablePart}值${rolePropertyValue}的${numericPart}倍`]
    }
    return ['0', '错误的基础值表述']
}

const capabilityConfigure = computed(() => store.state.capability_configure)
const capabilities = computed(() => {
    if (!capabilityConfigure.value) return {}
    return Object.assign({}, ...Object.values(capabilityConfigure.value).map(item => item?.children ?? {}))
})

export const getCapability = function (capabilityId, properties = {}) {
    const capability = capabilities.value[capabilityId.toString()]
    if (!capability) return '未知能力'
    let [baseValueCalc, baseValueDesc] = getCapabilityBaseValue(capability['base_value'], properties)
    const data = structuredClone(capability)
    data['baseValueCalc'] = baseValueCalc
    data['baseValueDesc'] = baseValueDesc
    return data
}

export const getCapabilitiesWithTypeId = function (typeId) {
    if (!capabilityConfigure.value) return {}
    const buffer = capabilityConfigure.value[typeId.toString()]
    if (!buffer) return {}
    return buffer?.children ?? {}
}

export const getOrganizationsDesc = (organization) => {
    if (!organization || organization.length === 0) return '不在档'
    // console.log('getOrganizationsDesc', JSON.stringify(organization))
    return organization.map(item => item.name).join('、')
}

export const getDifficultyDegree = (difficulty) => {
    difficulty = parseFloat(difficulty)
    if (difficulty >= 85) {
        return '深渊'
    } else if (difficulty >= 70) {
        return '高难'
    } else if (difficulty >= 60) {
        return '困难'
    } else if (difficulty >= 50) {
        return '通常'
    } else if (difficulty >= 40) {
        return '容易'
    } else {
        return '极易'
    }
}

export const getPropsRareLevelDesc = (status) => {
    switch (status) {
        case 0:
            return '常见'
        case 1:
            return '少有'
        case 2:
            return '珍稀'
        case 3:
            return '绝品'
        case 4:
            return '传说'
        default:
            return '不明'
    }
}

export const isValid = (item) => {
    if (!item) return false
    if (item.length === 0) return false
    if (item instanceof Object && Object.keys(item).length === 0) return false
    return true
}

export const calculateMD5 = (file, callback) => {
    const reader = new FileReader()
    reader.onload = (e) => {
        const fileContent = e.target.result
        const wordArray = CryptoJS.lib.WordArray.create(fileContent)
        const hash = CryptoJS.MD5(wordArray)
        callback(hash.toString())
    }
    reader.readAsArrayBuffer(file)
}

export const compressImage = (file, size, callback) => {
    // console.log('compress image', file.size / 1024, size / 1024)
    if (file.size <= size) {
        callback(file)
        return
    }

    const reader = new FileReader()
    reader.onload = (e) => {
        const img = new Image()
        img.onload = () => {
            const canvas = document.createElement('canvas')
            const ctx = canvas.getContext('2d')
            const MAX_WIDTH = 1024 // 最大宽度
            const MAX_HEIGHT = 1024 // 最大高度
            let width = img.width
            let height = img.height

            if (width > height) {
                if (width > MAX_WIDTH) {
                    height *= MAX_WIDTH / width
                    width = MAX_WIDTH
                }
            } else {
                if (height > MAX_HEIGHT) {
                    width *= MAX_HEIGHT / height
                    height = MAX_HEIGHT
                }
            }

            canvas.width = width
            canvas.height = height
            ctx.drawImage(img, 0, 0, width, height)

            canvas.toBlob((blob) => {
                const fileName = file.name.replace(/\.[^/.]+$/, '') + '.jpeg'
                const compressedFile = new File([blob], fileName, {type: 'image/jpeg'})

                // console.log('compressedFile size', compressedFile.size / 1024, size / 1024)

                if (compressedFile.size > size) {
                    compressImage(compressedFile, size, callback)
                } else {
                    callback(compressedFile)
                }
            }, 'image/jpeg', 0.7)
        }
        img.src = e.target.result
    }
    reader.readAsDataURL(file)
}

export const convertTreeData = ((dataArray) => {
    let buffer = {'C': [], 'B': [], 'A': [], 'S': [], 'SS': []}
    dataArray.forEach(item => {
        const key = item['degree']
        buffer[key].push(item)
    })
    buffer = Object.entries(buffer).filter(([key, value]) => {
        return key && value.length > 0
    })
    // console.log(JSON.stringify(buffer))
    return buffer
})

const findSkillInRow = (skillId, array) => {
    let buffer = array.filter(item => item.id === skillId)
    if (buffer.length !== 0) {
        return buffer[0]
    }

    for (const item of array.filter(item => item.subsequent)) {
        const skill = findSkillInRow(skillId, item.subsequent)
        if (skill) {
            return skill
        }
    }
    return null
}

export const sortedSkillData = ((data) => {
    let result = {}
    data.map(([key, skills]) => {
        let sortedSkills = skills.filter(skill => !skill.pre_skill)
        let subsequentSkills = []
        let buffer = skills.filter(skill => skill.pre_skill)

        while (buffer.length !== 0) {
            for (const skill of buffer) {
                let preSkill = findSkillInRow(skill.pre_skill.id, sortedSkills)
                if (preSkill) {
                    if (!preSkill.subsequent) {
                        preSkill.subsequent = [skill]
                    } else {
                        preSkill.subsequent.push(skill)
                    }
                    subsequentSkills.push(skill)
                    continue
                }

                preSkill = findSkillInRow(skill.pre_skill.id, buffer)
                if (!preSkill) {
                    sortedSkills.push(skill)
                }
            }
            buffer = buffer.filter(skill => !sortedSkills.includes(skill) && !subsequentSkills.includes(skill))
        }
        result[key] = sortedSkills.reverse()
    })
    // console.log(JSON.stringify(result))
    return result
})

export const getPerformanceDesc = (status) => {
    switch (status) {
        case 0:
            return '准备中'
        case 1:
            return '进行中'
        case 2:
            return '已谢幕'
    }
}

export const inApostleType = (userType) => {
    return [0, 2].includes(userType)
}

export const inOrganizationType = (userType) => {
    return [0, 1].includes(userType)
}

export const inLoggedType = (userType) => {
    return [0, 1, 2, 3].includes(userType)
}

export const isAdminType = (userType) => {
    return userType === 0
}

export const isApostleType = (userType) => {
    return userType === 2
}

export const isUserType = (userType) => {
    return userType === 3
}

const getDescriptiveDesc = (key) => {
    if (Object.keys(descriptiveDict).includes(key)) {
        return descriptiveDict[key]
    }
    return ''
}


const getResourceDesc = (key) => {
    if (Object.keys(resourceDict).includes(key)) {
        return resourceDict[key]
    }
    return ''
}

const getFactorDesc = (factor) => {
    if (factor === 1) {
        return ''
    } else if (factor === 0.5) {
        return '半数'
    }
    return `${factor} * `
}


export const parseToCostDesc = (cost) => {
    if (!cost) return ''

    const items = cost.split(';')

    // 处理每个成本项
    const buffer = items.map(item => {
        const parts = item.split(',')
        const descParts = parts.map((part, index) => {
            try {
                // 类型转换逻辑
                let descKey = parseFloat(part)
                if (isNaN(descKey)) {
                    descKey = part.toString()

                    return index === parts.length - 1
                        ? `${getResourceDesc(descKey)} `
                        : `${getDescriptiveDesc(descKey)} `
                }

                if (index === parts.length - 2) {
                    return `${descKey} `
                } else {
                    return getFactorDesc(descKey)
                }
            } catch (e) {
                console.error(`解析失败: ${part}`, e)
                return ''
            }
        })

        return descParts.join('')
    })

    return buffer.join('；')
}

export const getPercentage = (current, max) => {
    if (!max || max === 0) return 0.0
    if (current < 0 || max < 0) return 0.0

    const percentage = current / max * 100
    return percentage > 100 ? 100 : (percentage < 0 ? 0 : percentage)
}

export const uploadFile = async (file, md5Value, param) => {
    const formData = new FormData()
    formData.append('file', file)
    formData.set('name', file.name)
    formData.set('md5', md5Value)

    for (const key in param) {
        formData.set(key, param[key])
    }

    // formData.set('path', 'role_avatar')
    // formData.set('role_id', props.role.id)

    return await request('basic/upload_file/', formData, 'UPLOAD', {
        'Content-Type': 'multipart/form-data'
    })
}
